<template>
    <div class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center" style="z-index:51;">
        <div class="fixed inset-0 transition-opacity" @click="$emit('close')">
            <div class="absolute inset-0 bg-black opacity-75"></div>
        </div>
        <div class="bg-white overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
            <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div class="sm:flex sm:items-start">
                    <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                        <svg class="h-6 w-6 text-red-600" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
                        </svg>
                    </div>
                    <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                        <h3 class="text-lg leading-6 font-medium text-black" id="modal-headline">
                            <slot name="heading">Confirmation</slot>
                        </h3>
                        <div class="mt-2">
                            <p class="text-sm leading-5 text-charcoal-700">
                                <slot name="content">{{ 'Are you sure you want to ' + label  + '?' }}</slot>                                
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                    <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
                        <button type="button" class="inline-flex justify-center w-full border border-transparent px-4 py-2 bg-red-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:border-red-700 focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                            @click="$emit('confirm')">
                            <slot name="confirm-button">{{ label }}</slot>
                         </button>
                     </span>
                <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
                        <button type="button" class="inline-flex justify-center w-full border border-gray-500 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-900 shadow-sm hover:bg-gray-300 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                            @click="$emit('close')">
                        Cancel
                        </button>
                    </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ConfirmationModal",
        props:{
            label : {
                default: 'Confirm', 
                required: false
            }
        },
        mounted() {
            document.body.className = 'overflow-hidden';
        }
    }
</script>

<style scoped>

</style>
